module.exports = __webpack_public_path__ + "static/img/s-oppo-3.beb9f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-oppo-3.png
// module id = aW6S
// module chunks = 1